// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"nf","tile":"nh","imageWrapper":"ni","img":"nj","header":"nk","caption":"nl"};